<script>
	import PedScore from './PedScore.svelte';

	let pedPulse= 0;
	let pedTemp = 0;
	let pedRR = 0;
	let pedSat = 0;
	let pedResp =0;
	let pedAVPU = 0;
	let pedGut = 0;
	let pedOther =0;
	
	let convert = false;
	let Age = 0;

	function activetab() {
		let a = this.querySelector('input[type=radio]').value;
		let value = Math.abs(a);

		parent = Array.from(this.parentNode.children);
		parent.forEach(function (e,i) {
			e.classList.remove("active");
			if (e.classList.contains("last")) { 
				e.style["border-color"]= "black";
			} else {
				e.style["border-color"] = "rgba(172, 184, 184, 0.3)";
			}	
		});
	    this.classList.add("active");	
		if (value === 2) {
			this.style["border"] = "2px solid rgba(193,39,45,1)";
		
		} else if (value === 1) {
			this.style["border"] = "2px solid rgb(239, 135, 9)";

		} else {
			this.style["border"] = "2px solid rgba(0,146,69,1)";
		}
	
	};

	function sametab() {
		let a = this.querySelector('input[type=radio]').value;
		let value = Math.abs(a);

		parent = Array.from(this.parentNode.children);
		parent.forEach(function (e,i) {
			e.classList.remove("active-top");
			if (e.classList.contains("last")) { 
				e.style["border-color"]= "black";
			} else {
				e.style["border-color"] = "rgba(172, 184, 184, 0.3)";
			}	
		});
	    this.classList.add("active-top");
		this.style["border"] = "2px solid rgb(0,0,0)";	
		pedPulse = 0;
		pedRR = 0;
		pedTemp = 0; 

	};

</script>

<section>
	
	<div class="scoreSheet">	
		
		<div>	
			<div><p>Age</p></div>
				
			<div class="vitals grid-five-top">
				<label class="active-top" on:click={sametab}><input type=radio bind:group={Age} value={0}>0-1</label>
				<label on:click={sametab}><input type=radio bind:group={Age} value={1}>1-2</label>
				<label on:click={sametab}><input type=radio bind:group={Age} value={2}>3-4</label>
				<label on:click={sametab}><input type=radio bind:group={Age} value={3}>5-12</label>
				<label on:click={sametab}><input type=radio bind:group={Age} value={4}>13-16</label>
			</div>
		</div>
		<div>

		{#if Age ==  0}
		<div>
			<div class="topBar">
				<div><p>PULSE</p></div>
				<div><p class="subP">Score</p></div>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={2}>&lt; 90</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={1}>90-109</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedPulse} value={0}>110-160</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={1}>161-180</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={2}>&gt; 180</label>
				<label class="last">{pedPulse}</label>
			</div>
		</div>
		<div>
			<div><p>RESPIRATORY RATE</p></div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={2}>&lt; 25</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={1}>25-29</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedRR} value={0}>30-40</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={1}>41-49</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={2}>&ge; 50</label>
				<label class="last">{Math.abs(pedRR)}</label>
			</div>
		</div>	
		<div>			
			{#if convert == false}
			<div class="topTemp">
				<p>TEMPERATURE (&#176;C)</p>
				<label class="convert"><input type="checkbox" bind:checked={convert}/>  &#176;F</label>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&lt; 35</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>35-35.9</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedTemp} value={0}>36-37.5</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>37.6-39</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&gt; 39</label>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="last">{pedTemp}</label>
			</div>
			{:else}
			<div class="topTemp">
				<p>TEMPERATURE (&#176;F)</p>
				<label class="convert"><input type="checkbox" bind:checked={convert}/>  &#176;F</label>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={-3}>&lt; 95</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={-1}>95-96.6</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedTemp} value={0}>96.7-99.5</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>99.6-102</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&gt; 102</label>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="last">{Math.abs(pedTemp)}</label>
			</div>
			{/if}
		</div>
		{/if}

		{#if Age == 1}
		<div>
			<div class="topBar">
				<div><p>PULSE</p></div>
				<div><p class="subP">Score</p></div>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={2}>&lt; 90</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={1}>90-99</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedPulse} value={0}>100-150</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={1}>151-170</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={2}>&gt; 170</label>
				<label class="last">{pedPulse}</label>
			</div>
		</div>
		<div>
			<div><p>RESPIRATORY RATE</p></div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={2}>&lt; 20</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={1}>20-24</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedRR} value={0}>25-35</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={1}>36-50</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={2}>&gt; 50</label>
				<label class="last">{Math.abs(pedRR)}</label>
			</div>
		</div>
		<div>			
			{#if convert == false}
			<div class="topTemp">
				<p>TEMPERATURE (&#176;C)</p>
				<label class="convert"><input type="checkbox" bind:checked={convert}/>  &#176;F</label>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&le; 35</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>35.1-35.9</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedTemp} value={0}>36-37.9</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>38-40</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&gt; 40</label>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="last">{pedTemp}</label>
			</div>
			{:else}
			<div class="topTemp">
				<p>TEMPERATURE (&#176;F)</p>
				<label class="convert"><input type="checkbox" bind:checked={convert}/>  &#176;F</label>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={-3}>&le; 95</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={-1}>95.1-96.6</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedTemp} value={0}>96.7-100.2</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>100.2-104</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&ge; 104</label>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="last">{Math.abs(pedTemp)}</label>
			</div>
			{/if}
		</div>
		{/if}
		{#if Age == 2}
		<div>
			<div class="topBar">
				<div><p>PULSE</p></div>
				<div><p class="subP">Score</p></div>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={2}>&lt; 80</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={1}>80-94</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedPulse} value={0}>95-140</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={1}>141-160</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={2}>&gt; 160</label>
				<label class="last">{pedPulse}</label>
			</div>
		</div>
		<div>
			<div><p>RESPIRATORY RATE</p></div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={2}>&lt; 20</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={1}>20-24</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedRR} value={0}>25-30</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={1}>31-40</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={2}>&gt; 40</label>
				<label class="last">{Math.abs(pedRR)}</label>
			</div>
		</div>
		<div>			
			{#if convert == false}
			<div class="topTemp">
				<p>TEMPERATURE (&#176;C)</p>
				<label class="convert"><input type="checkbox" bind:checked={convert}/>  &#176;F</label>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&le; 35</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>35.1-35.9</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedTemp} value={0}>36-37.9</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>38-40</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&gt; 40</label>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="last">{pedTemp}</label>
			</div>
			{:else}
			<div class="topTemp">
				<p>TEMPERATURE (&#176;F)</p>
				<label class="convert"><input type="checkbox" bind:checked={convert}/>  &#176;F</label>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={-3}>&le; 95</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={-1}>95.1-96.6</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedTemp} value={0}>96.7-100.2</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>100.2-104</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&ge; 104</label>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="last">{Math.abs(pedTemp)}</label>
			</div>
			{/if}
		</div>
		{/if}
		{#if Age == 3}
		<div>
			<div class="topBar">
				<div><p>PULSE</p></div>
				<div><p class="subP">Score</p></div>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={2}>&lt; 70</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={1}>70-79</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedPulse} value={0}>80-110</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={1}>111-150</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={2}>&gt; 150</label>
				<label class="last">{pedPulse}</label>
			</div>
		</div>
		<div>
			<div><p>RESPIRATORY RATE</p></div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={2}>&lt; 20</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={1}>20-24</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedRR} value={0}>25-30</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={1}>31-40</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={2}>&gt; 40</label>
				<label class="last">{Math.abs(pedRR)}</label>
			</div>
		</div>
		<div>			
			{#if convert == false}
			<div class="topTemp">
				<p>TEMPERATURE (&#176;C)</p>
				<label class="convert"><input type="checkbox" bind:checked={convert}/>  &#176;F</label>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&le; 35</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>35.1-35.9</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedTemp} value={0}>36-37.9</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>38-40</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&gt; 40</label>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="last">{pedTemp}</label>
			</div>
			{:else}
			<div class="topTemp">
				<p>TEMPERATURE (&#176;F)</p>
				<label class="convert"><input type="checkbox" bind:checked={convert}/>  &#176;F</label>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={-3}>&le; 95</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={-1}>95.1-96.6</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedTemp} value={0}>96.7-100.2</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>100.2-104</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&ge; 104</label>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="last">{Math.abs(pedTemp)}</label>
			</div>
			{/if}
		</div>
		{/if}
		{#if Age == 4}
		<div>
			<div class="topBar">
				<div><p>PULSE</p></div>
				<div><p class="subP">Score</p></div>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={2}>&lt; 50</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={1}>50-59</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedPulse} value={0}>60-100</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={1}>101-110</label>
				<label on:click={activetab}><input type=radio bind:group={pedPulse} value={2}>&gt; 110</label>
				<label class="last">{pedPulse}</label>
			</div>
		</div>
		<div>
			<div><p>RESPIRATORY RATE</p></div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={2}>&lt; 12</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={1}>12-14</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedRR} value={0}>15-20</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={1}>21-25</label>
				<label on:click={activetab}><input type=radio bind:group={pedRR} value={2}>&gt; 25</label>
				<label class="last">{Math.abs(pedRR)}</label>
			</div>
		</div>
		<div>			
			{#if convert == false}
			<div class="topTemp">
				<p>TEMPERATURE (&#176;C)</p>
				<label class="convert"><input type="checkbox" bind:checked={convert}/>  &#176;F</label>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&le; 35</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>35.1-35.9</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedTemp} value={0}>36-37.9</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>38-40</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&gt; 40</label>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="last">{pedTemp}</label>
			</div>
			{:else}
			<div class="topTemp">
				<p>TEMPERATURE (&#176;F)</p>
				<label class="convert"><input type="checkbox" bind:checked={convert}/>  &#176;F</label>
			</div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={-3}>&le; 95</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={-1}>95.1-96.6</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedTemp} value={0}>96.7-100.2</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={1}>100.2-104</label>
				<label on:click={activetab}><input type=radio bind:group={pedTemp} value={2}>&ge; 104</label>
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label class="last">{Math.abs(pedTemp)}</label>
			</div>
			{/if}
		</div>
		{/if}	
		<div>
			<div><p>OXYGEN SATURATION</p></div>
			<div class="vitals grid-three">
				<label on:click={activetab}><input type=radio bind:group={pedSat} value={2}>&le; 89</label>
				<label on:click={activetab}><input type=radio bind:group={pedSat} value={1}>90-94</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedSat} value={0}>&ge; 95</label>
				<label class="last">{Math.abs(pedSat)}</label>
			</div>
		</div>
		<div>
			<div><p>BREATHING</p></div>
			<div class="vitals grid-five">
				<label on:click={activetab}><input type=radio bind:group={pedResp} value={2}>Stridor</label>
				<label on:click={activetab}><input type=radio bind:group={pedResp} value={1}>Grunt, wheeze</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedResp} value={0}>No distress</label>
				<label on:click={activetab}><input type=radio bind:group={pedResp} value={2}>Moderate Recession</label>
				<label on:click={activetab}><input type=radio bind:group={pedResp} value={1}>Severe Recession</label>
				<label class="last">{Math.abs(pedResp)}</label>
			</div>
		</div>
		<div>
			<div><p>GUT FEELING</p></div>
			<div class="vitals grid-three">
				<label on:click={activetab}><input type=radio bind:group={pedGut} value={2}>Child unwell</label>
				<label on:click={activetab}><input type=radio bind:group={pedGut} value={1}>Low concern</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={pedGut} value={0}>No distress</label>
				<label class="last">{Math.abs(pedGut)}</label>
			</div>
		</div>
		<div>
			<div><p>OTHER</p></div>
			<div class="vitals grid-three">
				<label on:click={activetab}><input type=radio bind:group={pedOther} value={2}>Oncology Patient</label>
				<label on:click={activetab}><input type=radio bind:group={pedOther} value={1}>Significant PMHx</label>
				<label on:click={activetab}><input type=radio bind:group={pedOther} value={2}>Congenital Heart Disease</label>
				<label class="last">{Math.abs(pedOther)}</label>
			</div>
		</div>
		
		<div class="grid-two">
			<PedScore {pedPulse} {pedTemp} {pedRR} {pedSat} {pedResp} {pedGut} {pedOther}/>
		</div>	
		<div><h5>Adapted from POPS (Pediatric Observation Priority Score)</h5></div>		
	</div>
</section>

<style>
	
	section {
		font-family: bebas-neue-by-fontfabric,sans-serif;
		font-weight: 700;
		font-style: normal;
		justify-content: center;
		align-items: center;
		color: rgba(0, 0, 0, 0.976);
		overflow: hidden;
		padding: 2rem 1rem 2rem 1rem;	

	}

	section h3 {
		font-size: 2rem;
		text-align: center;
	}

	section h5 {
		color: #00afaa;
	}

	p {
		text-align: left;
		font-size: 1rem;
		color:rgba(65, 64, 64, 1);
		margin: 0.4rem;
	}

	.topBar {
		display: grid;
		grid-template-columns: 1fr 1fr;
	}

	.topTemp {
		display: grid;
		grid-template-columns: 1fr 0.3fr;
	}
	.subP {
		text-align: right;
		font-size: 0.7rem;
	}
	
	.scoreSheet {
		width: 100%;
		margin-left: auto;
		margin-right: auto;
	}
	.vitals {
		border: 2px solid rgb(0, 0, 0);
		padding: 5px;
		text-align: center;
	}

	label {
		font-family: expressway,sans-serif;
		font-weight: 400;
		font-style: normal;
		display: inline-block;
		text-align: center;
		font-size: 0.8rem;
		border: 2px solid rgba(172, 184, 184, 0.3);
		border-radius: 0.2rem;
		padding: 0.08rem;
		background: transparent;
	}
	
	.convert {
		font-family: bebas-neue-by-fontfabric,sans-serif;
		font-weight: 700;
		font-style: normal;
		justify-content: center;
		align-items: center;
		margin: 0.4rem;
		font-size: 1rem;
		text-align: right;
		border: none;
		color: #00afaa;
	}

	.active {
		border: 2px solid rgba(0,146,69,1);
	}

	.active-top {
		border: 2px solid rgb(0,0,0);
		background-color:rgba(35, 175, 169, 0.07);
		color: rgb(0,0,0);
	}
	.last {
		border: 1px solid black;
	}
	
	input[type="radio"] {
		display: none;
		}

	
	.grid-three {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 60px;
	}

	.grid-five {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr 60px;
	}

	.grid-five-top {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	}	

	.smaller-label {
		font-size: 0.6rem;
	}

</style>